<template>
  <button
    v-ripple
    :class="['custom-button', className, classByType]"
    :disabled="disabled"
    type="button"
    @click="$emit('click', $event)"
  >
    <slot name="icon"></slot>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "CustomButton",
  directives: {
    ripple: {},
  },
  props: {
    className: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  computed: {
    classByType() {
      switch (this.type) {
        case "prime":
          return "primery";
        case "second":
          return "secondary";
        case "simple":
          return "simple";
        case "сomplex":
          return "сomplex";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../../scss/variables" as *;

.custom-button {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  width: 100%;
  border-radius: 100px;
  font-size: 18px;
  line-height: 1.2;
  font-weight: 700;
  padding: 18px 45px;
  margin: 5px 0;
  gap: 12px;
  color: var(--font-color);
  background-color: var(--league-body-color);
  transition:
    color 0.3s ease,
    background-color 0.3s ease,
    fill 0.3s ease,
    stroke 0.3s ease;

  &:hover {
    color: var(--font-color-hover);
    fill: var(--font-color-hover);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--font-color-hover);
  }
}

.custom-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.short {
  width: unset;
}

.simple {
  color: var(--back-color);
  fill: var(--back-color);
  background-color: var(--body-color);
  border: 1px solid var(--font-color);

  &:hover {
    color: var(--brand-color);
    fill: var(--brand-color);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--brand-color);
  }
}

.сomplex {
  color: var(--body-color);
  fill: var(--body-color);
  background-color: var(--back-color);
  border: 1px solid var(--body-color);

  &:hover {
    color: var(--brand-color);
    fill: var(--brand-color);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--brand-color);
  }
}

.primery {
  color: #ffffff;
  background-color: var(--success-color);
}

.secondary {
  color: #ffffff;
  background-color: var(--warning-color);
}

.dark path {
  stroke: var(--font-color);
}

@media screen and (max-width: $mobile) {
  custom-button {
    font-size: 16px;
  }
}
</style>
